export default () => {
  const stickyItem = document.getElementById('js-navigation');
  const keyvisual = document.getElementById('js-firstview');
  const parentItem = stickyItem.parentNode;

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  };

  const callback = (entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        stickyItem.classList.remove('is-sticky');
        stickyItem.classList.remove('is-slideIn');
        parentItem.style.paddingBottom = '0px';
      } else {
        stickyItem.classList.add('is-sticky');
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(keyvisual);

  let setPosition = 0;

  window.addEventListener('scroll', () => {
    if (setPosition < document.documentElement.scrollTop) {
      if (stickyItem.classList.contains('is-sticky')) {
        stickyItem.classList.remove('is-slideIn');
        stickyItem.classList.add('is-slideOut');
        parentItem.style.paddingBottom = '90px';
      }
    } else if (stickyItem.classList.contains('is-sticky')) {
      stickyItem.classList.add('is-slideIn');
      stickyItem.classList.remove('is-slideOut');
      parentItem.style.paddingBottom = '90px';
    }

    setPosition = document.documentElement.scrollTop;
  });
};
